module.exports = __webpack_public_path__ + "img/layout-chart.3d9cd3f9.svg";